import requests from "./httpService";

const PushMessageServices = {

    getMessage1 : async () =>{
        return requests.get(`/pushmessage/?data=message1`);
    },
    updateMessage : async (body) =>{
      
        return requests.patch(`/pushmessage/`,body);
    },
    
    getMessage : async () =>{
        return requests.get(`/pushmessage/`);
    },


}
export default PushMessageServices;